/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import { THEMES } from '../constants';
import { colors, createTheme, responsiveFontSizes } from '@material-ui/core';
import { softShadows } from './shadows';
import _ from 'lodash';
import typography from './typography';

const baseConfig = {
  direction: 'ltr',
  overrides: {
    MuiChip: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.075)'
      }
    },
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: 'hidden'
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32
      }
    }
  },
  typography
};

const themeConfigs = [
  {
    name: THEMES.LIGHT,
    overrides: {
      MuiInputBase: {
        input: {
          '&::placeholder': {
            color: colors.blueGrey[600],
            opacity: 1
          }
        }
      }
    },
    palette: {
      action: {
        active: colors.blueGrey[600]
      },
      background: {
        dark: '#f4f6f8',
        default: colors.common.white,
        paper: colors.common.white
      },
      primary: {
        main: colors.indigo[600]
      },
      secondary: {
        main: '#5850EC'
      },
      text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600]
      },
      type: 'light'
    },
    shadows: softShadows
  }
];

export function createMuiTheme(settings = {}) {
  let themeConfig = themeConfigs.find(theme => theme.name === settings.theme);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${settings.theme} is not valid`));
    [themeConfig] = themeConfigs;
  }

  let theme = createTheme(
    _.merge({}, baseConfig, themeConfig, { direction: settings.direction })
  );

  if (settings.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return theme;
}
